import { gql } from '@apollo/client';

export const PUBNUB_STATUS_ITEM_CREATED = gql`
  mutation PubNubStatusItemCreated($status_item: PubNubStatusItemModel!) {
    PubNubStatusItemCreated(statusItem: $status_item) @client
  }
`;
